import { Icon, Scrollbar } from '@aibees/shared/components';
import { Button, Stack, Tooltip } from '@mui/material';
import * as Styled from './styles';
import * as SX from './sx';
import { TabLayoutProps, Tabs } from './types';

export default function TabLayout({
  children,
  tabs,
  header,
  subHeader,
  footer,
  handleChangeTabs,
}: TabLayoutProps) {
  const handleClick = (tab: Tabs) => {
    if (tab.disabled) return;
    handleChangeTabs(tab);
  };
  return (
    <Styled.Wrapper direction="row">
      <Stack alignItems="center" sx={SX.tabWrapper}>
        {tabs.map((t) => (
          <Tooltip title={t.disabledText} placement="right" key={t.title}>
            <Button
              sx={SX.button(t.active, t.disabled)}
              onClick={() => handleClick(t)}
            >
              <Icon name={t.icon} sxx={SX.icon} />
            </Button>
          </Tooltip>
        ))}
      </Stack>

      <Stack className="TabLayoutHeader" sx={SX.content}>
        {header}
        {subHeader}
        <Scrollbar>{children}</Scrollbar>
        {footer}
      </Stack>
    </Styled.Wrapper>
  );
}
